import { useRef, useState } from "react";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";

// Product-page hero video for the Complete Rugby Kit. Autoplays muted + loops (so it starts
// on every device incl. mobile via playsInline), preserves the clip's native aspect ratio
// (object-contain, never stretched), and exposes a small play/pause + sound toggle.
export default function KitVideo({ srcMp4, srcWebm, poster, className = "" }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(true);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) { v.play(); setPlaying(true); }
    else { v.pause(); setPlaying(false); }
  };
  const toggleMute = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <div className={`relative bg-black border border-[#262626] overflow-hidden flex items-center justify-center ${className}`} data-testid="kit-video-wrap">
      <video
        ref={ref}
        data-testid="kit-video"
        poster={poster || undefined}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="w-full h-auto max-h-[78vh] object-contain block"
      >
        {srcMp4 && <source src={srcMp4} type="video/mp4" />}
        {srcWebm && <source src={srcWebm} type="video/webm" />}
      </video>
      <div className="absolute bottom-3 right-3 flex items-center gap-2">
        <button
          type="button"
          onClick={togglePlay}
          data-testid="kit-video-playpause"
          aria-label={playing ? "Pause video" : "Play video"}
          className="w-9 h-9 flex items-center justify-center bg-black/60 hover:bg-[#F7931E] hover:text-black text-white backdrop-blur transition-colors"
        >
          {playing ? <Pause size={16} /> : <Play size={16} />}
        </button>
        <button
          type="button"
          onClick={toggleMute}
          data-testid="kit-video-mute"
          aria-label={muted ? "Unmute video" : "Mute video"}
          className="w-9 h-9 flex items-center justify-center bg-black/60 hover:bg-[#F7931E] hover:text-black text-white backdrop-blur transition-colors"
        >
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
        </button>
      </div>
    </div>
  );
}
